import { inject, observer } from 'mobx-react';
import React, { useContext, useEffect } from 'react';

import { AppContextType } from '@byted-cg/linkchat-plugin';

import { Icon } from '../components/Icon';
import classes from '../constants/classes';
import { prefixCls } from '../utils/style';
import { LocalProvider } from './index';
import LazyComponent from './LazyComponent';
import { IToolButton, IToolPanelConfig, ToolTypes } from './type';
import { LayoutEventBus } from '..';

interface ToolPanelOptions {
  appContext?: AppContextType;
  config?: IToolPanelConfig;
  quickHidden?: boolean;
  style?: React.CSSProperties;
}
const ToolPanel = React.forwardRef<HTMLDivElement, ToolPanelOptions>(
  ({ config: configList, appContext, quickHidden, style }, ref) => {
    const { getRemoteComponent } = useContext(LocalProvider);
    useEffect(() => {
      configList?.map((item) => {
        if (item?.icon && typeof item.icon !== 'string')
          getRemoteComponent(item.icon);
      });
    }, [configList]);

    const useFunction =
      (config: IToolButton) =>
      (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        appContext?.eventBus?.publish(LayoutEventBus.toolPanelClick, config);
        switch (config.type) {
          case ToolTypes.cmd:
            appContext?.cmd?.send(config.data);
            break;
          case ToolTypes.url:
            appContext?.jsBrige?.openWindow(config.data);
            break;
          default:
            if (config.data && typeof config.data === 'function') {
              config.data(appContext, config);
            }
            break;
        }
      };
    return (
      <div
        className={prefixCls(
          {
            [`${classes.prefix}ToolPanel`]: true,
            hasQuickBtnGroup: !quickHidden,
          },
          false,
        )}
        style={style}
        ref={ref}
      >
        {configList?.length
          ? configList.map(
              ({ icon, ...config } = {} as IToolButton, index) =>
                icon && (
                  <div
                    className="toolItem"
                    key={`${config.label}--${index}`}
                    onClick={useFunction({ icon, ...config })}
                  >
                    {typeof icon === 'string' ? (
                      <React.Fragment>
                        <div className="toolItemIconWrapper">
                          <Icon
                            key={`${config.label}--${index}`}
                            className="toolItemIcon"
                            type={icon as 'Folder'}
                          />
                        </div>
                        <span className="toolItemLabel">{config.label}</span>
                      </React.Fragment>
                    ) : (
                      <LazyComponent
                        className="toolItemIconWrapper"
                        key={`${config.label}--${index}`}
                        config={icon}
                        layoutConfig={config}
                        extraData={{ previewLikeH5: 1 }}
                      />
                    )}
                  </div>
                ),
            )
          : null}

        {/* Layout placeholder use */}
        {Array.from({ length: 10 }).map((i, index) => (
          <i key={`place-${index}`}></i>
        ))}
      </div>
    );
  },
);
export default inject(({ appContext }) => ({
  appContext,
}))(observer(ToolPanel));
